module.exports = __webpack_public_path__ + "static/media/idlepage-products.d41cb0b8.svg";